// Vendors
import React, { useEffect, useState } from 'react';
import { connectStats } from 'react-instantsearch-dom';
import classnames from 'classnames';

const ResultsFoundHeader = ({ nbHits }) => {
  const [inView, setInView] = useState(false);
  const classNames = classnames('section__header', {
    [`section__header--in-view`]: inView
  });

  useEffect(() => {
    setTimeout(() => {
      setInView(true);
    }, 1000);
  }, []);

  return (
    <header className={classNames}>
      <p className="section__title u--margin-top-0 u--margin-bottom-0 u--text-align-center-sm-max u--margin-bottom-20-sm-max u--margin-left-5-md-min">
        <span>
          {nbHits === 1 ? `${nbHits} Items Found` : `${nbHits} Items Found`}
        </span>
      </p>
    </header>
  );
};

export default connectStats(ResultsFoundHeader);
